export enum SCHEDULE_TYPES {
  SDL_SET_DATA_EMPRESA = 'SDL_SET_DATA_EMPRESA',
  SDL_SET_DATA_SUCURSALES = 'SDL_SET_DATA_SUCURSALES',
  SDL_SET_SUCURSAL_SELECTED = 'SDL_SET_SUCURSAL_SELECTED',
  SDL_SET_FORM_HORARIO = 'SDL_SET_FORM_HORARIO',
  SDL_SET_ERRORS_FORM_HORARIO = 'SDL_SET_ERRORS_FORM_HORARIO',
}